import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import Modal from '../../Modal/Modal';
import Heading from '../../Typography/Heading/Heading';
import Button from '../../Button/Button';
import styles from './JoinToGuildModal.module.scss';
import { joinGuild } from '../../../store/reducers/Guild/guildRequest';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import cn from 'classnames';
import Loader from '../../Loader/Loader';
import { useNavigate } from 'react-router-dom';
import { GuildActionsName } from '../../../store/reducers/Guild/guildType';
import { clearData } from '../../../store/reducers/Guild/slice';
const JoinToGuildModal = ({ closeModal, title, buttonName, id }) => {
    const dispatch = useAppDispatch();
    const { pending, error, isDataSent } = useAppSelector((state) => state.guild);
    const navigate = useNavigate();
    useEffect(() => {
        if (!error && isDataSent.includes(GuildActionsName.JOIN_GUILD)) {
            closeModal();
            dispatch(clearData(GuildActionsName.JOIN_GUILD));
            navigate(`/social/guild/${id}`);
        }
    }, [id, error, isDataSent, navigate, dispatch, closeModal]);
    return (_jsxs(Modal, Object.assign({ background: true, closeModal: closeModal }, { children: [_jsx(Heading, { className: styles.heading, title: title }), pending.includes(GuildActionsName.JOIN_GUILD) ? (_jsx(Button, { className: cn('w-100 flex-1'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { onClick: () => dispatch(joinGuild(id)), size: '100', height: 'sm', text: buttonName }))] })));
};
export default JoinToGuildModal;
